import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

const EMPTY_ENT = { features: [], plan: "starter", role: "user" };

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauth, object = auth
  const [ent, setEnt] = useState(EMPTY_ENT);

  const loadEnt = useCallback(() => {
    return api.get("/me/entitlements").then((r) => setEnt(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => { setUser(r.data); loadEnt(); })
      .catch(() => setUser(false));
  }, [loadEnt]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    await loadEnt();
    return data;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    setUser(data);
    await loadEnt();
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(false);
    setEnt(EMPTY_ENT);
  };

  return (
    <AuthContext.Provider value={{
      user, setUser, login, register, logout,
      features: ent.features, plan: ent.plan, role: ent.role, status: ent.status,
      refreshEntitlements: loadEnt,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
